//Mã nguồn NSNN
export default {
  S05: 0, // Thông tư 107/2017/TT-BTC
  S05_2Ben: 1, // Mẫu số dư hai bên
};
